import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { AuthService } from '../auth.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.page.html',
  styleUrls: ['./change-password.page.scss'],
})
export class ChangePasswordPage implements OnInit, OnDestroy {
  resetSub: Subscription;
  showOTP = false;
  emailtoReset = '';
  OTP = '';
  constructor(
    private alertCtrl: AlertController,
    private router: Router,
    private authService: AuthService,
    private loadingCtrl: LoadingController
  ) {}

  ngOnInit() {}
  ngOnDestroy() {
    if (this.resetSub) {
      this.resetSub.unsubscribe();
    }
  }

  sendOTP(email) {
    if (email.value && email.value.trim().length > 0) {
      const emailVal = email.value;
      this.loadingCtrl
        .create({
          keyboardClose: true,
          showBackdrop: false,
          message: 'Please wait...',
        })
        .then((loadingEl) => {
          loadingEl.present();
          this.resetSub = this.authService.sendPasswordOTP(emailVal).subscribe({
            next: (res) => {
              loadingEl.dismiss();
              if (res) {
                this.showOTP = true;
                this.emailtoReset = emailVal;
                this.alertCtrl
                  .create({
                    header: 'OTP Sent',
                    message:
                      'Please check your email for the OTP we just sent. If you don’t see it, check your spam or junk folder.',
                    buttons: [
                      {
                        text: 'Dismiss',
                      },
                    ],
                  })
                  .then((alertEl) => alertEl.present());
              } else {
                this.loadingCtrl.dismiss();
                this.alertCtrl
                  .create({
                    header: 'Invalid Email',
                    message:
                      'Make sure you entered the correct email or try again later.',
                    buttons: [
                      {
                        text: 'Dismiss',
                        handler: () => {
                          this.alertCtrl.dismiss();
                        },
                      },
                    ],
                  })
                  .then((alertEl) => alertEl.present());
              }
            },
            error: () => loadingEl.dismiss(),
          });
        });
    } else {
      this.alertCtrl
        .create({
          message: 'Please enter a valid email to reset your password.',
          buttons: [{ text: 'Dismiss' }],
        })
        .then((alertEl) => alertEl.present());
    }
  }
  resetPassword(email) {
    if (this.emailtoReset && this.emailtoReset.trim().length > 0) {
      const emailVal = this.emailtoReset;
      this.loadingCtrl
        .create({
          keyboardClose: true,
          showBackdrop: false,
          message: 'Please wait...',
        })
        .then((loadingEl) => {
          loadingEl.present();
          this.resetSub = this.authService
            .resetPassword(emailVal, this.OTP)
            .subscribe({
              next: (res) => {
                loadingEl.dismiss();
                if (res) {
                  email.value = '';
                  this.OTP = '';
                  this.showOTP = false;
                  this.alertCtrl
                    .create({
                      header: 'Your Password is Reset',
                      message:
                        'You will receive further instruction via e-mail.',
                      buttons: [
                        {
                          text: 'Dismiss',
                          handler: () => {
                            this.router.navigate(['/signin']);
                          },
                        },
                      ],
                    })
                    .then((alertEl) => alertEl.present());
                } else {
                  this.loadingCtrl.dismiss();
                  this.alertCtrl
                    .create({
                      header: 'An Error Occured',
                      message:
                        'Make sure you the OTP you entered is correct and try again.',
                      buttons: [
                        {
                          text: 'Dismiss',
                          handler: () => {
                            this.alertCtrl.dismiss();
                          },
                        },
                      ],
                    })
                    .then((alertEl) => alertEl.present());
                }
              },
              error: () => loadingEl.dismiss(),
            });
        });
    } else {
      this.alertCtrl
        .create({
          message: 'Please enter a valid email to reset your password.',
          buttons: [{ text: 'Dismiss' }],
        })
        .then((alertEl) => alertEl.present());
    }
  }

  changeEmail() {
    this.showOTP = false;
    this.OTP = '';
  }
}
